import api from "./api";

export async function listTasks(filters = {}) {
  const { data } = await api.get("/api/tasks", { params: filters });
  return data;
}

export async function getTask(taskId) {
  const { data } = await api.get(`/api/tasks/${taskId}`);
  return data;
}

export async function createTask(payload) {
  const { data } = await api.post("/api/tasks", payload);
  return data;
}

export async function updateTask(taskId, patch) {
  const { data } = await api.patch(`/api/tasks/${taskId}`, patch);
  return data;
}

export async function deleteTask(taskId) {
  await api.delete(`/api/tasks/${taskId}`);
  return true;
}

export async function regenerateForDebate(sessionId) {
  const { data } = await api.post(
    `/api/tasks/regenerate-from-debate/${sessionId}`,
  );
  return data;
}

export async function regenerateOnboardingSeeds() {
  const { data } = await api.post("/api/tasks/regenerate-onboarding-seeds");
  return data;
}
